import { array, boolean, struct, tuple } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as ClientId } from '../../client/Id';
import { Id as JobTypeId } from '../../job/job-type';
import { Id as RequirementId } from '../../report/RequirementsWithUnknown';

export const FilterRequest = struct({
	client: array(ClientId),
	jobType: array(JobTypeId),
	requirements: array(array(RequirementId)),
	createdAt: tuple(iotsUtils.ValidDate, iotsUtils.ValidDate),
	showCompleted: boolean,
});
